import CTNButton from '@ctn/ui/components/ctn-button';
import { type CTNButtonProps } from '@ctn/ui/types/ctn-button';
import classNames from 'classnames';
import { useMemo } from 'react';

const classNameComponent = 'c-pnp-button-group';

export type ButtonOfGroup = CTNButtonProps & { id: string };
export type GroupButtonsProps = {
	readonly className?: string;
	readonly left?: ButtonOfGroup[];
	readonly right?: ButtonOfGroup[];
};

const GroupButtons = ({ className, left, right }: GroupButtonsProps) => {
	const groupButtonsClassName = useMemo(() => classNames(className, classNameComponent), [className]);

	return (
		<ul className={groupButtonsClassName}>
			{right && right.length > 0 && (
				<>
					{right.map((buttonProps) => (
						<li key={buttonProps.id} className={`${classNameComponent}__item ${classNameComponent}__item--right`}>
							<CTNButton minWidth="140" size="size-40" {...buttonProps} />
						</li>
					))}
				</>
			)}
			{left && left.length > 0 && (
				<>
					{left.map((buttonProps) => (
						<li key={buttonProps.id} className={`${classNameComponent}__item ${classNameComponent}__item--left`}>
							<CTNButton minWidth="140" size="size-40" {...buttonProps} />
						</li>
					))}
				</>
			)}
		</ul>
	);
};

export default GroupButtons;
